import { Component, OnInit,ChangeDetectorRef} from '@angular/core';
import { FormBuilder, FormGroup} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {  PopupModalComponent } from 'app/shared/popup-modal/popup-modal.component';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';

@Component({
  selector: 'app-edit-enrolment',
  templateUrl:'./edit-enrolment.component.html',
  styleUrls: ['./edit-enrolment.component.scss']
})
export class EditEnrolmentComponent implements OnInit {
  enrolmentModel = {
    name: '',
    email: '',
    phone: '',
    college: '',
    coursecatinterest_id: '',
    skillsinterest_id: [],
    course_id: '',
    batch_id: '',
    discounts_ids: [],
    total_fees: '',
    net_fees: '',
    payable_amount: '',
    hunting_by: '',
    farming_by: '',
    status: '',
    payment_status:'',
    notes: '',
    admin_notes: '',
    user_id: { _id: '' },
    next_payment_date:"",
    date_of_joining:moment().toISOString(),
    learning_mode:'',
    team:'',
    goal:'',
    next_action:null,
    last_activedate:"",
    lastresponse:"",
    batch_schedule:null
  }
  enrolmentId: any
  enrolmentForm: FormGroup;
  courseList = []
  selectedCourse: "";
  categoryList = [];
  tagsList = [];
  batchList = [];
  selectedBatch = null
  selectedBatch_schedule = null
  skillTags: string[] = [];
  selectedCategory = null
  discountList = []
  min_next_payment_date: any
  selectedDiscount: string[] = [];
  pamentStatusList = [
    // { name: 'pending' },
    { name: 'received',label:'Payment Received' },
    { name: 'due',label:'Payement Due' },
    // { name: 'completed',label:'Completed' },
    // { name: 'left',label:'Left' },
  ]
  selectedPaymentStatus = 'due'
  selectedStatus = 'enrolled'
  catId = '6319d5025ab9e462a96cfbba'
  skillId = '6319d3595ab9e462a96cfb06'
  batchId = '6319d2985ab9e462a96cfae0'
  goalId = '631ad878ce5c666542591bd4'
  teamId = '631ad9b6ce5c666542591be9'
  learningModeId='631ad8abce5c666542591bd9'
  skillList = [];
  teamList = [];
  goalList = [];
  usersList = [];
  paid_amount: any;
  selectedHuntingBy = '63358024efa8a87882968210';
  selectedFarmingBy = '63358024efa8a87882968210';
  goal='6325ccdbbc4b543c7a24294f';
  team='6325cd6cbc4b543c7a242988';
  collegeList: any[] = [];
  selectedCollege = null
  selectLearningMode='6325cd99bc4b543c7a24298f'
  learningList=[]
  public user = {
    p1: 'college',
    p2: 'batch'
  }
  paymentMode=[]
  paymentModeId='631ada2ace5c666542591bf6'
  selectedPaymentMode=null
  businessTypeCompany_Id=''
  businessTypeCollege_Id='6325cdefbc4b543c7a2429a4'
  isEnrolmentEdit:boolean=false 
  currentUrl:any
  agency=null
  agency_List=[
    { name:'Meander Software' , _id:'Meander_Software'},
    { name:'Vlogic Labs', _id:'Vlogic_Labs'},
    { name:'Drawtopic', _id:'Drawtopic'},
  ]
  list_type_cat_id:any
  list_type =[]
  selected_check_list = null
  sprint_id:any

  nextaction_tagcat_id = '63e39b572052e0098e18dfc2'
  nextactionList = []
  selected_mentor:string[]=[]
  selected_buddy:string[]=[]
  batchSchedule_list=[]
  env_url = environment.name
  
  constructor(private ref: ChangeDetectorRef,
    private apiService: ApiService, public toastr: ToastrService,
    private formBuilder: FormBuilder,
    private activatedroute: ActivatedRoute,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private route: Router) {
      this.currentUrl=this.activatedroute.snapshot.routeConfig.path
      this.activatedroute.paramMap.subscribe(params => {
      this.enrolmentId = params.get('id');
      this.getNextActionTags()
    })
  }

  ngOnInit(): void {
   
    if(this.currentUrl == 'enrollment-edit/:id'){
      this.isEnrolmentEdit=false
      this.agency = 'Meander_Software'
    }
    if(this.currentUrl == 'edit/:id'){
      this.isEnrolmentEdit=true
      this.agency = 'Meander_Software'
    }
    this.getEnrolmentById();
    this.getAllCollege();
    this.getCheckListType()
    this.getTagByCategory();
    this.getSkillTagByCategory();
    this.getGoalTagByCategory();
    this.getTeamTagByCategory();
    this.getCourseList();
    this.getBatchList();
    this.getBatchSchedule()
    this.getDiscountList();
    this.getUsers();
    this.paymentModeList()
    this.getModeTagByCategory()
    // this.getCategoryById()
    this.min_next_payment_date=new Date().toISOString().slice(0, 10);

  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.ref.detectChanges();
    }, 100);

  }
  getCheckListType(){
    this.apiService.getTagByTagCatgoryId('65268dbf37d5731c9401d3fe').subscribe((res:any)=>{
      this.list_type_cat_id = res?.data?.filter(item => item.name == 'quick' )
      if(this.list_type_cat_id){
        this.getCheckList()
      }
    })
  }
  getCheckList() {
    this.apiService.getAllChecklist(1, 100,this.list_type_cat_id[0]?._id).subscribe((res: any) => {
      this.list_type = res?.data?.items
    })
  }
  getCheckListId(event){
    this.selected_check_list
    if(this.selected_check_list){
      this.apiService.getSprintByChecklistId(this.selected_check_list).subscribe((res:any)=>{
        this.sprint_id = res?.data[0]?.sprint[0]._id
      })
    }
  }
  getAllCollege(){
    this.apiService.getBusinessByTypeId('6325cdefbc4b543c7a2429a4').subscribe((res:any)=>{
      this.collegeList=res.data
    })
  }
  getCollegeId(event:any){
    this.selectedCollege
  }
  updateBusiness(id, data) {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    let model = {
      is_activated: data
    }
    this.apiService.updateBusiness(id, model).subscribe((res: any) => {
      if (res.isSuccess) {
        this.getAllCollege()
        this.spinner.hide()
      }
    })
  }
  checkIfCollegeActivated(collegeId) {
    const index = this.collegeList.findIndex(x => x._id == collegeId)
    if (index >= 0) {
      return this.collegeList[index].is_activated
    }
    return false
  }
  getUsers() {
    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
      this.usersList = res?.items
    })
  }
  getHuntId(event: any) {
    this.selectedHuntingBy
    if(this.enrolmentId){
      this.enrolmentModel.hunting_by = this.selectedHuntingBy
    }

  }
  getFarmId(event: any) {
    this.selectedFarmingBy
    if(this.enrolmentId){
      this.enrolmentModel.farming_by = this.selectedFarmingBy
    }
  }
  getEnrolmentById() {
    this.apiService.getEnrolmentById(this.enrolmentId).subscribe((res: any) => {
      this.enrolmentModel.name = res?.data[0]?.name
      this.enrolmentModel.email = res?.data[0]?.email
      this.enrolmentModel.phone = res?.data[0]?.phone

      this.selectedCollege = res?.data[0]?.college?._id
      this.enrolmentModel.college = this.selectedCollege

      this.selectedCategory = res?.data[0]?.coursecatinterest_id?._id
      this.enrolmentModel.coursecatinterest_id = this.selectedCategory

      this.enrolmentModel.date_of_joining = res?.data[0]?.date_of_joining
      this.enrolmentModel.name = res?.data[0]?.name
      this.selectedPaymentStatus = res?.data[0]?.payment_status

      if(res?.data[0]?.hunting_by?._id){
        this.selectedHuntingBy = res?.data[0]?.hunting_by?._id
        this.enrolmentModel.hunting_by = this.selectedHuntingBy
      }
      if(res?.data[0]?.farming_by?._id){
        this.selectedFarmingBy = res?.data[0]?.farming_by?._id
        this.enrolmentModel.farming_by = this.selectedFarmingBy
      }
      

      this.selectedCourse = res?.data[0]?.course_id?._id
      this.enrolmentModel.course_id = this.selectedCourse

      this.selectedBatch = res?.data[0]?.batch_id?._id
      this.enrolmentModel.batch_id = this.selectedBatch
      this.selectedBatch_schedule = res?.data[0]?.batch_schedule?._id
      this.enrolmentModel.batch_schedule = this.selectedBatch_schedule
      if(res?.data[0]?.goal?._id){
        this.goal = res?.data[0]?.goal?._id;
      }
      if(res?.data[0]?.team?._id){
        this.team = res?.data[0]?.team?._id;
      }
      if(res?.data[0]?.learning_mode){
        this.selectLearningMode = res?.data[0]?.learning_mode
        this.enrolmentModel.learning_mode = this.selectLearningMode
      }
      

      this.selectedCollege = res?.data[0]?.college?._id

      this.enrolmentModel.total_fees = res?.data[0]?.total_fees
      this.enrolmentModel.net_fees = res?.data[0]?.net_fees

      this.skillTags = res?.data[0]?.skillsinterest_id.map((item) => item._id)
      this.enrolmentModel.skillsinterest_id = this.skillTags
      // for (let item of this.enrolmentModel.discounts_ids) {
      //   this.selectedDiscount.push(item)
      // }
      if( res?.data[0]?.discounts_ids){
        this.selectedDiscount = res?.data[0]?.discounts_ids.map((item)=> item._id)
        this.enrolmentModel.discounts_ids = this.selectedDiscount
      }
     
      this.enrolmentModel.user_id._id = res?.data[0]?.user_id?._id
     
    })
  }
 
  getTagByCategory() {
    this.apiService.getTagByTagCatgoryId(this.catId).subscribe((res: any) => {
      this.categoryList = res.data
    })
  }

  getSkillTagByCategory() {
    this.apiService.getTagByTagCatgoryId(this.skillId).subscribe((res: any) => {
      this.skillList = res.data
    })
  }

  getGoalTagByCategory() {
    this.apiService.getTagByTagCatgoryId(this.goalId).subscribe((res: any) => {
      this.goalList = res.data
    })
  }
  getGoalId(event){
    this.goal
    if(this.enrolmentId){
      this.enrolmentModel.goal = this.goal
    }

  }
  getTeamTagByCategory() {
    this.apiService.getTagByTagCatgoryId(this.teamId).subscribe((res: any) => {
      this.teamList = res.data
    })
  }
  getTeamId(event){
    this.team
    if(this.enrolmentId){
      this.enrolmentModel.team = this.team
    }
  }
  getModeTagByCategory(){
    this.apiService.getTagByTagCatgoryId(this.learningModeId).subscribe((res:any)=>{
      this.learningList=res.data
    })
  }
  getModeId(event:any){
    this.selectLearningMode
    if(this.enrolmentId){
      this.enrolmentModel.learning_mode = this.selectLearningMode
    }
  }

  getBatchList() {
    this.apiService.getBatchListByStatus('64423a83fca16673d960a454').subscribe((res: any) => {
      this.batchList = res.data.items
    })
  }
  getBatchSchedule() {
    let tag_cat_id
      if(this.env_url ==='dev'){
        tag_cat_id ='681c9516a637a836a5f8863b'
      }
      if(this.env_url ==='prod'){
        tag_cat_id ='681c9e22e9c3d0fc4b93394b'
      }
    this.apiService.getTagByTagCatgoryId(tag_cat_id).subscribe((res: any) => {
      this.batchSchedule_list = res?.data
    })
  }
 
  getBatchId(event: any) {
    this.selectedBatch
    if(this.enrolmentId){
      this.enrolmentModel.batch_id = this.selectedBatch
    }
  }
  getBatchScheduleId(event: any) {
    this.selectedBatch_schedule
  }
  getCategoryId(event: any) {
    this.selectedCategory
    if(this.enrolmentId){
      this.enrolmentModel.coursecatinterest_id = this.selectedCategory
    }
  }
  
  getCourseList() {
    this.apiService.getCourseList(1, 1000).subscribe((res: any) => {
      this.courseList = res.data.items
    })
  }
  getCourseId(event: any) {
    this.selectedCourse
    if(this.enrolmentId){
      this.enrolmentModel.course_id = this.selectedCourse
    }
    this.getCoursebyId()
  }
  getCoursebyId() {
    this.apiService.getCourseById(this.selectedCourse).subscribe((res: any) => {
      this.enrolmentModel.total_fees = res?.data[0]?.total_fees
      this.enrolmentModel.net_fees = res?.data[0]?.total_fees
    })
  }
  getDiscountList() {
    this.apiService.getAllDiscounts(1, 100).subscribe((res: any) => {
      this.discountList = res.data.items
    })
  }
  getDiscountByCourseId() {
    if (this.selectedDiscount.length < 1) {
      this.enrolmentModel.net_fees = this.enrolmentModel.total_fees;
      this.paid_amount = this.enrolmentModel.total_fees;
    } else {
      let body = {
        courseId: this.selectedCourse,
        discountId: this.selectedDiscount
      }
      this.apiService.getDiscountByCourseId(body).subscribe((res: any) => {
        this.enrolmentModel.total_fees = res.data.courseFee;
        this.enrolmentModel.net_fees = res.data.netFees;
        this.paid_amount = res.data.netFees;
      })
    }
  }

   getDiscountById(){
    this.apiService.getDiscountById(this.selectedDiscount).subscribe((res:any)=>{
    })
   }
  getDiscountId(event: any) {
    this.selectedDiscount
    if(this.enrolmentId){
      this.enrolmentModel.discounts_ids = this.selectedDiscount
    }
    this.getDiscountById()
    this.getDiscountByCourseId()
  }

  getAgencyId(event: any){
    this.agency
  }
  submit() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    let body = {
      name: this.enrolmentModel.name,
      email: this.enrolmentModel.email,
      phone: this.enrolmentModel.phone,
      college: this.selectedCollege,
      coursecatinterest_id: this.selectedCategory,
      skillsinterest_id: this.skillTags,
      goal: this.goal,
      learning_mode:this.selectLearningMode,
      team: this.team,
      hunting_by: this.selectedHuntingBy,
      farming_by: this.selectedFarmingBy,
      course_id: this.selectedCourse,
      batch_id: this.selectedBatch,
      total_fees: this.enrolmentModel.total_fees,
      net_fees: this.enrolmentModel.net_fees,
      discounts_ids: this.selectedDiscount,
      payable_amount: this.enrolmentModel.payable_amount,
      status: this.selectedStatus,
      payment_status:this.selectedPaymentStatus,
      notes: this.enrolmentModel.notes,
      admin_notes: this.enrolmentModel.admin_notes,
      next_payment_date:this.enrolmentModel.next_payment_date,
      date_of_joining:this.enrolmentModel.date_of_joining,
      agency: this.agency,
      next_action: this.enrolmentModel.next_action,
      last_activedate: this.enrolmentModel.last_activedate,
      lastresponse: this.enrolmentModel.lastresponse,
      checklist: '6545195d15950cbce9ddc5ad',
      sprint : '6545195d15950cbce9ddc5af',
      // checklist : "6545db054ae8739ffc6f922a",
      // sprint : "6545db054ae8739ffc6f922c"
      buddy_id : this.selected_buddy,
      mentor_id : this.selected_mentor,
      batch_schedule : this.selectedBatch_schedule,
    }
    if(this.currentUrl == 'enrollment-edit/:id'){
      if (this.enrolmentId) {
        this.apiService.updateEnrolment(this.enrolmentId, body).subscribe((res: any) => {
          this.spinner.hide()
          if (res.isSuccess === true) {
              this.sendMail(res?.data?.email)
              this.transaction();
            this.toastr.success('Updated Successfully')
            swal.fire({
              title: "Success!",
              text: `${this.enrolmentModel.name} login password is combination of name's first 4 letters (capital) and phone number's last 4 digits`,
              icon: "success",
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              buttonsStyling: false,
            });
            // this.route.navigate(['/enrollments/enrollment-list'])
             history.back()
          }
          else {
            this.toastr.error(res.error)
          }
        })
      }
      else {
        this.toastr.error('enrolrment id missing !!')
      }
    }
    else if(this.currentUrl == 'edit/:id'){
      if (this.enrolmentId) {
        this.apiService.updateEnrolment(this.enrolmentId, body).subscribe((res: any) => {
          this.spinner.hide()
          if (res.isSuccess === true) {
            this.toastr.success('Updated Successfully')
            this.route.navigate(['/enrollments/enrollment-view',this.enrolmentId])           
          }
          else {
            this.toastr.error(res.error)
          }
        })
      }
      else {
        this.toastr.error('enrolrment id missing !!')
      }
    }
  
  }
  paymentModeList(){
    this.apiService.getTagByTagCatgoryId(this.paymentModeId).subscribe((res: any) => {
      this.paymentMode = res.data
    })
  }
  getPaymentModeId(event:any){
    this.selectedPaymentMode
    if(this.enrolmentId){
      // this.enrolmentModel.pa = this.selectedPaymentMode
    }
  }
  transaction() {
    let body = {
      net_amount: this.enrolmentModel.net_fees,
      paid_amount: this.paid_amount,
      course_id: this.selectedCourse,
      discounts_ids: this.selectedDiscount,
      student: this.enrolmentModel?.user_id?._id,
      entity_id: this.enrolmentId,
      payment_status:this.selectedPaymentStatus,
      mode:this.selectedPaymentMode
    }
    this.apiService.createTransaction(body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        // this.toastr.success(res.message)
      }
      else {
        // this.toastr.error(res.error)
      }
    })
  }
 
  getAllBatch() {
    this.apiService.getBatchList(1, 10).subscribe((res: any) => {
    })
  }
  goToPage(){
    this.route.navigate(['/business/add'])
  }
  openContent(data: any) {
    let number = data;
    const modalRef = this.modalService.open(PopupModalComponent);
    switch (number) {
      case 1:
        modalRef.componentInstance.user = this.user.p1;
        modalRef.result.then((data) => {
          if (data == "success") {
            this.getAllCollege()
          }
          // on close
        }, (reason) => {
          // on dismiss
        });
        break;
      case 2:
        modalRef.componentInstance.user = this.user.p2;
        modalRef.result.then((data) => {
          if (data == "success") {
            this.getAllBatch()
          }
          // on close
        }, (reason) => {
          // on dismiss
        });
        break;
    }
  }
  back(){
    this.route.navigate(['/enrollments/enrollment-view',this.enrolmentId])
  }
  sendMail(email){
    if(email){
      this.apiService.sendMail(email).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success(res.message)
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
  }
  getNextActionTags() {
    this.apiService.getTagByTagCatgoryId(this.nextaction_tagcat_id).subscribe((res: any) => {
      this.nextactionList = res?.data
    })
  }
  getChangeNextAction(event) {
    this.enrolmentModel.next_action
  }
  getMentorId(event){
    this.selected_mentor
  }
  getBuddyId(event){
    this.selected_buddy
  }
}

